import { Component, inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UsersService } from '@core/services/users.service';
import { EntityCtrlDirective } from '@shared/directives/table-ctrl.directive';
import { User } from '@shared/models';
import { first, Observable, switchMap } from 'rxjs';
import { RegisterAdminFormComponent } from 'src/app/modules/dashboard/components/register-admin-form/register-admin-form.component';
import {
  MatCard,
  MatCardHeader,
  MatCardTitle,
  MatCardActions,
  MatCardContent,
  MatCardFooter,
} from '@angular/material/card';
import { MatMiniFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatDivider } from '@angular/material/divider';
import { TableUsersComponent } from '../table-users/table-users.component';
import { TablePaginatorComponent } from '../table-paginator/table-paginator.component';

@Component({
  selector: 'app-table-users-ctrl',
  templateUrl: './table-users-ctrl.component.html',
  styleUrl: './table-users-ctrl.component.scss',
  imports: [
    MatCard,
    MatCardHeader,
    MatCardTitle,
    MatCardActions,
    MatMiniFabButton,
    MatIcon,
    MatDivider,
    MatCardContent,
    TableUsersComponent,
    MatCardFooter,
    TablePaginatorComponent,
  ],
})
export class TableUsersCtrlComponent extends EntityCtrlDirective<User> {
  private readonly usersService = inject(UsersService);

  @Input() userMenuContainer: string[];

  override entity$: Observable<{
    data: User[];
    hasNextPage: boolean;
    length: number;
    page: number;
  }> = this.pageNumber.pipe(
    switchMap((pageNumber) =>
      this.usersService.getAll({ page: pageNumber, limit: 20 })
    )
  );

  private readonly dialog = inject(MatDialog);

  onRefresh(): void {
    this.pageNumber.next(this.pageNumber.value);
  }

  openCreate(): void {
    const dialogRef = this.dialog.open(RegisterAdminFormComponent);
    dialogRef
      .afterClosed()
      .pipe(first())
      .subscribe(() => {
        this.onRefresh();
      });
  }
}
